// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.facts-table {
  position: relative;
  width: 100%;
  height: 100%;
  scroll-behavior: smooth;
  overflow: hidden;
}
.facts-table .table-header {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  height: 60px;
  width: 100%;
  background-color: white;
  padding: 16px;
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(211, 211, 211, 0.373);
}
.facts-table .table-body {
  position: absolute;
  flex: 1;
  width: 100%;
  top: 60px;
  height: calc(100% - 60px);
  overflow: auto;
  padding: 20px 6px;
  display: flex;
  flex-direction: column;
}
.facts-table .table-body .fact-container {
  border-bottom: 1px solid #bbb;
}
.facts-table .table-body .fact-container .ant-collapse-header {
  background-color: white;
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: none !important;
}
.facts-table .table-body .fact-container .ant-collapse-header .ant-collapse-header-text {
  width: calc(100% - 24px);
}
.facts-table .table-body .fact-container .ant-collapse-header .ant-collapse-header-text .fact-name {
  width: 100%;
  display: flex;
  padding: 16px 2px 16px 0;
  justify-content: space-between;
  align-items: center;
}
.facts-table .table-body .fact-container .ant-collapse-content .ant-collapse-content-box {
  padding: 0 0 18px 0;
  color: rgba(0, 0, 0, 0.85) !important;
  background-color: white;
}
.show-all-container {
  font-size: 12px;
}
.show-all-container .checkbox-container {
  display: flex;
  align-items: center;
}
.show-all-container .checkbox-container .text {
  margin-left: 8px;
}
.show-all-container .divider {
  margin: 4px 0 4px 0;
}
.long-fact-table-answer {
  width: 80%;
  word-wrap: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/details/runs/items/FactsTableV3.less"],"names":[],"mappings":"AAIA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;AAHF;AAFA;EAQI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mDAAA;AAHJ;AAjBA;EAwBI,kBAAA;EACA,OAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AAJJ;AAMI;EACE,6BAAA;AAJN;AAMM;EACE,uBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAJR;AAKQ;EACE,wBAAA;AAHV;AAIU;EACE,WAAA;EACA,aAAA;EACA,wBAAA;EACA,8BAAA;EACA,mBAAA;AAFZ;AAQQ;EACE,mBAAA;EACA,qCAAA;EACA,uBAAA;AANV;AAaA;EACE,eAAA;AAXF;AAaE;EACE,aAAA;EACA,mBAAA;AAXJ;AAYI;EACE,gBAAA;AAVN;AAcE;EACE,mBAAA;AAZJ;AAgBA;EACE,UAAA;EACA,qBAAA;AAdF","sourcesContent":["// TODO: Convert this file into a modular CSS file\n\n@import '@css/variables.less';\n\n.facts-table {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  scroll-behavior: smooth;\n  overflow: hidden;\n\n  .table-header {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1;\n    height: 60px;\n    width: 100%;\n    background-color: white;\n    padding: 16px;\n    font-size: 18px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid rgba(211, 211, 211, 0.373);\n  }\n\n  .table-body {\n    position: absolute;\n    flex: 1;\n    width: 100%;\n    top: 60px;\n    height: calc(100% - 60px);\n    overflow: auto;\n    padding: 20px 6px;\n    display: flex;\n    flex-direction: column;\n\n    & .fact-container {\n      border-bottom: 1px solid #bbb;\n\n      & .ant-collapse-header {\n        background-color: white;\n        padding: 0;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        border: none !important;\n        & .ant-collapse-header-text {\n          width: calc(100% - 24px);\n          & .fact-name {\n            width: 100%;\n            display: flex;\n            padding: 16px 2px 16px 0;\n            justify-content: space-between;\n            align-items: center;\n          }\n        }\n      }\n\n      & .ant-collapse-content {\n        & .ant-collapse-content-box {\n          padding: 0 0 18px 0;\n          color: rgba(0, 0, 0, 0.85) !important;\n          background-color: white;\n        }\n      }\n    }\n  }\n}\n\n.show-all-container {\n  font-size: 12px;\n\n  & .checkbox-container {\n    display: flex;\n    align-items: center;\n    & .text {\n      margin-left: 8px;\n    }\n  }\n\n  & .divider {\n    margin: 4px 0 4px 0;\n  }\n}\n\n.long-fact-table-answer {\n  width: 80%;\n  word-wrap: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
